(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  (function() {
    var phoneViewport = window.matchMedia('(max-width: 749px)');

    function initializeMobileDisclosures() {
      document.querySelectorAll('.wm-mobile-disclosure').forEach(function(details) {
        if (details.dataset.wmDisclosureBound === 'true') return;
        details.dataset.wmDisclosureBound = 'true';
        details.open = !phoneViewport.matches;

        function revealLinkedFinder() {
          if (details.id && window.location.hash === '#' + details.id) {
            details.open = true;
          }
        }

        revealLinkedFinder();
        window.addEventListener('hashchange', revealLinkedFinder);
        phoneViewport.addEventListener('change', function() {
          if (details.isConnected) details.open = !phoneViewport.matches;
        });
      });
    }

    initializeMobileDisclosures();
    document.addEventListener('shopify:section:load', initializeMobileDisclosures);
  })();

  } catch(e) { console.error(e); }
})();
})();
